const jobParser = (job) => {
  if (job === "" || job === "Filmmaker" || job === "Agency Creative") {
    return job
  } else {
    return "Other Storyteller"
  }
}

export default jobParser
